import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { ProjectCommentModel } from "../../models/ProjectCommentModel";
import ProjectCommentService from "../../services/ProjectCommentService";
import ProjectCommentSlice from "../slices/ProjectCommentSlice";
import { RootState } from "../store";

export const ProjectCommentActions = ProjectCommentSlice.actions;
export const fetchProjectComment = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch, getState) => {
    if (getState().projectComments.all_ProjectComments.length === 0) {
      const response: ProjectCommentModel[] =
        await ProjectCommentService.getAllProjectComments();
      dispatch(ProjectCommentActions.setProjectComments(response));
    }
  };
};
export const fetchParticularProjectComment = (
  ProjectComment_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response: ProjectCommentModel =
      await ProjectCommentService.getParticularProjectComment(
        ProjectComment_id
      );
    dispatch(ProjectCommentActions.setParticularProjectComment(response));
  };
};
export const fetchParticularProjectAllComments = (
  Project_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    const response =
      await ProjectCommentService.getParticularProjectAllComments(Project_id);
    response.length === 0
      ? dispatch(ProjectCommentActions.setParticularProjectAllComments([]))
      : dispatch(
          ProjectCommentActions.setParticularProjectAllComments(response)
        );
  };
};
export const setParticularProjectParticularComment = (
  projectComment: ProjectCommentModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    await ProjectCommentService.setParticularProjectParticularComment(
      projectComment
    );
    dispatch(ProjectCommentActions.appendProjectComment(projectComment));
  };
};

export const setProjectCreationComment = (
  projectComment: ProjectCommentModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch(ProjectCommentActions.setProjectCreationComment(projectComment));
  };
};
